import DataMgr from "../DataMgr";
import Util from "@/Master/Util";
import { fwkConst } from "@/Fwk/FwkConst";
import UtilUrl from "@/Core/UtilUrl";
import {masterConst} from "@/Master/Const/MasterConst";
import {UpdateMainState} from "@/app/MainSliceUtil";
import {Attribution} from "@/Fwk/Channel/Attribution";
import UtilBrowser from "@/Master/UtilBrowser";
import KitPwa from "@/Master/PWA/KitPwa";
import AESHelper from "@/Fwk/Encrypt/AESHelper";

export default class ChannelMgr {
    static tag: string = `[归因信息]`;

    // static channelDataKey:string = 'ChannelDataKey';
    // static channelQidKey:string = 'ChannelQidKey';//

    static newQID: string;
    static _channelQid: string;
    static _attributionData: Attribution;
    static isInitOk = false;

    static get channelQid(){
        if (this._channelQid) return this._channelQid;
        return '';
    }

    static get getQid(){
        if (this.channelQid) return `?qid=${this.channelQid}`;
        return '';
    }

    static get channelAttributionData(){
        if (this._attributionData) return this._attributionData;
        return '';
    }

    static getNewParam(){
        const curPar = UtilUrl.params?.toString() || '';
        const newPar = new URLSearchParams(curPar);
        if (ChannelMgr.channelQid){
            newPar.set("qid",ChannelMgr.channelQid);
        }
        return newPar;
    }

    static Init(): void {
        if (!Util.isWindow) return;
        if (this.isInitOk)return;
        this.isInitOk = true;
        if (Util.isLog){
            console.group(`${this.tag}`)
            console.log(this.tag,'初始化-开始');
        }
        let qid = DataMgr.getStorage(fwkConst.CHANNEL_QID, '');

        if (!qid){
            qid = UtilUrl.getParam('qid') || UtilUrl.getParam('QID');//只要有QID就必须通过后端获取渠道信息。
            if (qid){
                DataMgr.setStorage(fwkConst.CHANNEL_QID, qid);
            }
            if (Util.isLog){
                console.log(this.tag,'初始化-开始 获取链接上的参数',qid);
            }
        }
        if (Util.isLog){
            console.log(this.tag,'初始化-开始 开始获取QID',qid);
        }

        if (qid){
            if (Util.isLog){
                console.log(this.tag,'初始化-开始 已有QID信息。qid=',qid);
            }
            UtilUrl.setParam('qid', qid);
            const cuid = UtilUrl.getParam('cuid');
            if (cuid){
                try {
                    //解密字符串
                    const uidStr = AESHelper.DecryptWeb(cuid);
                    if (uidStr){
                        const uids = uidStr.split('|');
                        if (uids.length >= 2){
                            const uuid = uids[0];
                            let endTime = Number(uids[1]);
                            if (isNaN(endTime)) endTime = 0;
                            if (uuid && endTime > 0 && Util.localTimeStamp < endTime){
                                Util.setH5UUID(uuid);
                                if (Util.isLog){
                                    console.log(this.tag, '在有效的时间内，带过来的uuid并设置', uuid);
                                }
                            }
                        }
                    }
                }catch(e){
                    if (Util.isLog){
                        console.log(this.tag, '解密信息错误', e);
                    }
                }
            }

            this.setChannelQID(qid);
            this.setChannelOk();
            return;
        }
        const attribution = DataMgr.getStorage(fwkConst.CHANNEL_ATTR);
        if (Util.isLog){
            console.log(this.tag,'初始化-开始 本地attribution=',attribution);
        }
        if (attribution){
            this.setAttributionData(attribution);
            this.setChannelOk();
        }else{
            this.checkChannel();
        }
    }

    static setChannelQID(qid: string): void {
        this._channelQid = qid;
        UpdateMainState(this.tag,{
            channelQid:qid,
        });
    }

    static setAttributionData(data: Attribution): void {
        this._attributionData = data;
        UpdateMainState(this.tag,{
            attributionData:data,
        });
        if (data.h5_channel_qid){
            this.setChannelQID(data.h5_channel_qid);
        }
    }

    //设置归因回调
    static setAttributionDataAsync(data: Attribution): void {
        if (Util.isLog){
            console.group(this.tag,'设置归因回调');
        }

        //储存基础归因信息 只做获取不做其他处理
        DataMgr.setStorage(fwkConst.CHANNEL_ATTR, data);

        if (data.h5_channel_qid){
            DataMgr.setStorage(fwkConst.CHANNEL_QID, data.h5_channel_qid);
            UtilUrl.setParam('qid',data.h5_channel_qid);
        }

        this.setAttributionData(data);

        //todo 要找后台和打数据确认，如果跨浏览器了，但是是一个用户，这个UUID是否需要设置成同一个。
        if (data.adid){
            Util.setH5UUID(data.adid);
        }

        if (Util.isLog){
            console.log(this.tag,'设备信息','getOsName=',UtilBrowser.getOsName,'getBrowserName=',UtilBrowser.getBrowserName);
        }

        //只是针对安卓使用 跳转方法
        if (Util.isAndroid){
            if (Util.isLog){
                console.log(this.tag,'是安卓设备');
                console.log(this.tag,KitPwa.isPWAInstallSupported ? '支持PWA就不跳浏览器了':'不支持PWA跳转google浏览器');
            }
            //不支持PWA的都主动去跳转google浏览器
            if (!KitPwa.isPWAInstallSupported){
                const curUrl = UtilUrl.getOpenUrl;
                setTimeout(()=>{
                    UtilBrowser.openInChrome(curUrl);
                });
            }
        }
        if (Util.isLog){
            console.groupEnd();
        }
    }

    static setChannelOk(){
        UpdateMainState('ChannelMgr',{isChannelOk:true});
        if (Util.isLog){
            console.log(this.tag,'设置渠道准备完成');
            console.groupEnd();
        }
    }


    //提前处理链接参数 并储存在本地，等待使用
    static checkChannel(){
        const urlParams = UtilUrl.getAllParams;
        let attribution = {} as Attribution;

        const id = UtilUrl.getParam('utm_id'); //广告系列ID - 用于识别此引荐引用的广告系列。使用utm_id来识别特定的广告系列。
        const source = UtilUrl.getParam('utm_source');//活动来源 - 使用utm_source来识别各种自定义渠道来源/还有搜索。
        const medium = UtilUrl.getParam('utm_medium');//竞选媒介 CPC/CPA/CPI
        const campaign = UtilUrl.getParam('utm_campaign');//渠道活动
        const adgroup = UtilUrl.getParam('utm_adgroup');//广告组
        const creative = UtilUrl.getParam('utm_creative');//创意组
        const term = UtilUrl.getParam('utm_term');//竞选期限 用于付费搜索。使用utm_term记录此广告的关键字。
        const content = UtilUrl.getParam('utm_content');//活动内容 - 用于 A/B 测试和内容定位广告。使用utm_content区分指向同一 URL 的广告或链接。

        //这个是Facebook渠道，自动生成的广告ID,用于这个标记为买量。
        const fbFbpId = this.getFbPid;
        const fbClickId = UtilUrl.getParam('fbclid');

        //本地生成唯一QID;
        const qid = this.h5QID;
        const h5UUID = Util.h5UUID;
        //设置过期时间。5分钟内打开才有效果，在首个浏览器的情况下，每隔10秒更新
        const endTime = Util.localTimeStamp + 60 * 10;
        //记录参数信息到本地
        attribution.h5_channel_qid = qid;
        attribution.adid = h5UUID;
        attribution.h5_source = source;
        attribution.trackerName = source;
        attribution.trackerToken = source;
        attribution.network = source;
        attribution.campaign = campaign;
        attribution.adgroup = adgroup;
        attribution.creative = creative;
        attribution.h5_medium = medium;
        attribution.h5_term = term;
        attribution.h5_content = content;
        attribution.h5_e_time = endTime;
        attribution.urlParams = urlParams;

        // const isBuyUser = !(!source) && !source.toLowerCase().concat('organic');

        //这个是facebook买量标记
        // if (fbFbpId && fbClickId && source) {
        if (source) {
            //todo 1首次登陆游客接口时，先把渠道信息上传，后端返回QID参数（记录了渠道信息）。
            attribution.h5_state = 'installed';
            //todo 2在其他浏览器通过QID参数形式访问，通过QID找后台拿到渠道信息。返回后再设置到本地，并自动回调。
        } else {
            attribution.h5_state = 'organic';
        }

        //清除链接上的参数信息内容。
        UtilUrl.clearParams();

        //设置QID到链接参数上
        UtilUrl.setParam('qid', qid);

        const uid = `${h5UUID}|${endTime}`;
        const cuid = AESHelper.EncryptWeb(uid);
        UtilUrl.setParam('cuid', cuid);

        // UtilUrl.setParam('et', endTime+'');

        //储存基础归因信息 只做获取不做其他处理
        DataMgr.setStorage(fwkConst.CHANNEL_ATTR, attribution);
        DataMgr.setStorage(fwkConst.CHANNEL_QID, qid);
        //设置渠道归因数据，上下游
        this.setAttributionData(attribution);
        //设置QID，到本地和上下游
        // this.setChannelQID(qid);
        if (Util.isLog){
            console.log(this.tag, '设置参数到本地-首次访问设置', attribution);
        }
        this.setChannelOk();
    }

    //获取本地FB的cookie信息
    static get getFbPid() {
        let fbPid = document.cookie.match(/(^|;) ?_fbp=([^;]*)(;|$)/);
        if (fbPid) {
            return fbPid[2];
        } else {
            return null;
        }
    }

    /**
     * 获取 Web UUID
     */
    static get getWebGAID(): string {
        const adjustAttrObj = this.getAdjustAttrObj;
        if (adjustAttrObj) {
            const attrObj = adjustAttrObj as unknown as Attribution;
            if (attrObj){
                return attrObj.adid;
            }
        }
        return '';
    }

    /**
     * 获取 Adjust 渠道信息归因信息，从 localStorage
     */
    static get getAdjustAttrObj(): string {
        const adjustAttr = DataMgr.getStorage(fwkConst.CHANNEL_ATTR);
        // if (Util.isLog) {
        //     console.log(ChannelMgr.tag, JSON.stringify(adjustAttr));
        // }
        if (adjustAttr) {
            try {
                return JSON.stringify(adjustAttr);
            } catch (e) {
                console.error(`${this.tag} 解析 Adjust 归因信息时出错:`, e);
            }
        }
        return '';
    }

    /**
     * 从归因信息中获取指定字段
     * @returns 指定字段的值
     */
    static getAttribute(): Attribution {
        const attribution = DataMgr.getStorage(fwkConst.CHANNEL_ATTR);
        if (attribution){
            return attribution as Attribution;
        }
        return {} as Attribution;
    }

    /**
     * 跟踪事件
     * @param obj - 事件对象
     */
    static trackEvent(obj: any): void {
        // this.Adjust.trackEvent(obj);
    }

    /**
     * H5随机ID 每个浏览器都不一样
     */
    static get h5QID(): string {
        const storedUUID = DataMgr.getStorage(masterConst.H5_QID) as string;
        // 如果本地存储中存在有效的 UUID，直接返回
        if (typeof storedUUID === 'string' && storedUUID.length > 5) {
            return storedUUID;
        }
        if (this.newQID){
            return this.newQID;
        }
        const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let newQID = '';
        for (let i = 0; i < 8; i++) {
            // 随机获取一个字符拼接
            const randomIndex = Math.floor(Math.random() * chars.length);
            newQID += chars[randomIndex];
        }
        // 将新的 UUID 储存在本地
        DataMgr.setStorage(masterConst.H5_QID, newQID);
        this.newQID = newQID;
        return newQID;
    }


}
